/* eslint-disable max-len */
import Question from 'images/coin-pages/questions/hbar.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const hbarPage: ICoinPageData = {
  title: 'coin_456',
  description: 'coin_457',
  // description: 'coin_458',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Hedera (HBAR)' }) }} />
  ),
  questionsBlock: {
    image: Question,
    questions: [
      {
        title: 'coin_459',
        answer: 'coin_460',
      },
      {
        title: 'coin_461',
        answer: 'coin_462',
      },
      {
        title: 'coin_463',
        answer: 'coin_464',
      },
      {
        title: 'coin_465',
        answer: 'coin_466',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Hedera (HBAR)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_467',
        text: ['coin_469'],
      },
      {
        title: 'coin_468',
        text: ['coin_470'],
      },
    ],
    blogCards: [blogCards.borrowLikePro, blogCards.cryptoCrash],
  },
}
